
namespace Gamification.Gamification {
    export class ProdottiRisorseColumns {
        static columnsKey = 'Gamification.ProdottiRisorse';
    }
}